import { QueryClient } from "@tanstack/react-query";

/**
 * Shared query client for the Zeus frontend.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (failureCount >= 2) {
          return false;
        }
        if (error && typeof error === `object` && `status` in error) {
          const status = Number((error as { status?: number }).status);
          if (!Number.isNaN(status) && status < 500) {
            return false;
          }
        }
        return true;
      },
    },
  },
});
